/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useEventListener } from './useEventListener';

type Keys = number | number[];
interface Props {
  next?: Keys;
  prev?: Keys;
  last?: Keys;
  first?: Keys;
  select?: Keys;
  initial?: number;
  itemsNumber: number;
  active: number;
  // shouldLoop?: boolean,
  onSelect: (hovered: number) => void;
}

function isCase(keyCode: number, key: Keys) {
  return Array.isArray(key) ? key.includes(keyCode) : keyCode === key;
}

export function useListInteractions<T extends HTMLElement>({
  next = 40,
  prev = 38,
  last = 35,
  first = 36,
  initial = 0,
  select = 32,
  onSelect,
  itemsNumber,
  active
}: // shouldLoop  = true // TODO
Props): { listWrapperRef: React.RefObject<T> } {
  const listWrapperRef = useRef<T>(null);
  const isVisited = useRef<boolean>(false);
  const [hovered, setHovered] = useState(initial);

  const handleKeyDown = useCallback(
    (event) => {
      isVisited.current = true;
      const { keyCode } = event;
      let nextItem;
      switch (true) {
        case isCase(keyCode, next):
          nextItem = hovered + 1;
          setHovered(nextItem === itemsNumber ? 0 : nextItem);
          break;
        case isCase(keyCode, prev):
          nextItem = hovered - 1;
          setHovered(nextItem < 0 ? itemsNumber - 1 : nextItem);
          break;
        case isCase(keyCode, last):
          event.preventDefault();
          setHovered(itemsNumber - 1);
          break;
        case isCase(keyCode, first):
          event.preventDefault();
          setHovered(0);
          break;
        case isCase(keyCode, select):
          event.preventDefault();
          onSelect(hovered);
          break;
        case keyCode === 9: // tab
          setHovered(active);
          break;
        default:
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hovered, itemsNumber, next, prev, last, first, select, isVisited, active]
  );

  useEventListener('keydown', handleKeyDown, listWrapperRef.current);

  useEffect(() => {
    const { children } = listWrapperRef.current! as unknown as {
      children: HTMLButtonElement[];
    };
    if (isVisited.current) {
      // to prevent autofocus
      children[hovered]?.focus();
    }
  }, [listWrapperRef, hovered, isVisited]);

  return { listWrapperRef };
}
